// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__TfHr9","label":"SetPasswdForm_label__fIP5f"};